import { Container, Row, Col, Button } from '@themesberg/react-bootstrap';
import React, { useState, useEffect } from 'react';
import { get, post } from '../../../services/back.service';
import { uploadWithSignedUrl } from '../../../utils/uploadSignedUrl';
import useAutosave from '../../../hooks/useAutosave';

const FormVehiclePictureRecord = ({ id }) => {
  const [bodyImages, setbodyImages] = useState([]);
  const [msgButton, setMsgButton] = useState('Guardar Informacion')

  const autosave = useAutosave(async () => {
    const images = bodyImages.map(({ base64, ...rest }) => rest);
    await post('/peritaje/modifyinspection/pictures/' + id, {
      type: 'RI',
      images
    });
  });

  const deleteImage = async (name) => {
    autosave.cancel();
    setbodyImages((prev) => prev.filter((e) => (e.original_name || e.name) !== name));
    const input = document.getElementById(name);
    if (input) input.value = null;
    await get(`/peritaje/deleteimage/${id}`, {}, { 'type': 'RI', 'name': name });
  };

  const showConvertImage = async ({ target }) => {
    const { files } = target;
    const tmpFile = bodyImages;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      try {
        const metadata = await uploadWithSignedUrl(file, id, 'RI', 'images');
        const preview = URL.createObjectURL(file);
        const image = { ...metadata, name: metadata.original_name, base64: preview };
        const index = tmpFile.findIndex((current) => current.name === image.name);
        if (index >= 0) {
          tmpFile[index] = image;
        } else {
          tmpFile.push(image);
        }
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    }

    setbodyImages([...tmpFile])
    autosave.schedule();
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    let respo;
    const images = bodyImages.map(({ base64, ...rest }) => rest);
    const body = {
      type: 'RI',
      images
    };
    respo = await post('/peritaje/modifyinspection/pictures/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    };
  };

  useEffect(() => {
    const initForm = async () => {
      const respo = await get('/peritaje/downloadimages/RI/' + id, {});
      if (respo.success) {
        let finalData = respo.data;
        // if (finalData.length < 12) finalData.push({})
        setbodyImages(finalData);
      }
    };
    initForm();
  }, [id]);

  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">Fotos Vehiculo</h1>
          <h4 className="fw-bold">Fotos para registro(no saldran en el pdf)</h4>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <div className="image-upload-wrap">
          <input className="file-upload-input" multiple type='file' onChange={(e) => { showConvertImage(e); }} accept="image/*" />
          <div className="drag-text">
            <h3>Drag and drop a file or select add Image</h3>
          </div>
        </div>
        <div className="side_view">
          {
            bodyImages.map((image, i) => {
              return <div key={i}><img
                id={image.name}
                alt="sin imagen"
                src={image.base64}
              />
                <Button type="button" variant="outline-primary" onClick={(e) => deleteImage(image.name)}>borrar</Button>
              </div>
            })
          }
        </div>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default FormVehiclePictureRecord;